import request from '../untils/request';

export const replenishList = params => {
  return request({
    url: '/goods/replenish-goods/replenish-list',
    params,
    authCode: 'REPLENISH-GOODS_REPLENISH-LIST',
  });
};

export const replenishUpdateApi = params => {
  return request({
    url: '/goods/replenish-goods/update-replenish',
    params,
    authCode: 'REPLENISH-GOODS_REPLENISH-LIST',
  });
};

export const replenishMemberList = params => {
  return request({
    url: '/goods/replenish-goods/replenish-member-list',
    params,
    authCode: 'REPLENISH-GOODS_REPLENISH-LIST',
  });
};

export const goodsScopeGoodsStockApi = params => {
  return request({
    url: '/goods/goods-basic/edit-goods-stock',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const replenishBasicMemberList = params => {
  return request({
    url: '/goods/replenish-goods/replenish-goods-basic-list',
    params,
    authCode: 'REPLENISH-GOODS_REPLENISH-LIST',
  });
};

export const replenishGoodsBasicDetail = params => {
  return request({
    url: '/goods/replenish-goods/goods-basic-detail',
    params,
    authCode: 'REPLENISH-GOODS_REPLENISH-LIST',
  });
};

export const dynamicGoodsDetailRequest = params => {
  return request({
    url: '/goods/goods-basic/goods-storage-and-sales',
    params,
  });
};

export const dynamicAddCartNums = params => {
  return request({
    url: '/statistics/data-sec-kill/add-cart-num',
    params,
  });
};